import React from "react";
import { Card } from "@radarly/models/cards";
import {
  isCardSortable,
  isCardWithDisplayedValues,
  isCardWithEvolutionSelector,
  isCardWithNullValues,
} from "@radarly/models/cards/is";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import PeriodEvolution from "../../shared/period-evolution";
import MainUnit from "./main-unit";
import { useSetDataviz } from "./model";
import NullValues from "./null-values";
import SecondaryUnit from "./secondary-unit";
import Sort from "./sort";

export interface HorizontalBarChartSidebarOptionsProps {
  dataviz: DatavizHorizontalBarChart;
  setCard?: (card: Card) => void;
  card: Card;
  color: React.ReactElement;
}

export default function HorizontalBarChartSidebarOptions({
  dataviz,
  setCard,
  card,
  color,
}: HorizontalBarChartSidebarOptionsProps) {
  const { setDataviz } = useSetDataviz(card, setCard);
  return (
    <>
      {isCardWithDisplayedValues(card) && (
        <MainUnit dataviz={dataviz} setDataviz={setDataviz} />
      )}
      {isCardWithEvolutionSelector(card) && (
        <>
          <PeriodEvolution card={card} setCard={setCard} />
          <SecondaryUnit dataviz={dataviz} setDataviz={setDataviz} />
        </>
      )}
      {isCardWithNullValues(card) && (
        <NullValues dataviz={dataviz} setDataviz={setDataviz} />
      )}
      {color}
      {isCardSortable(card) && (
        <Sort card={card} dataviz={dataviz} setDataviz={setDataviz} />
      )}
    </>
  );
}
